export const TAIRYU_IGNITION_FILTER_TYPE_ALL = 'all';
export const TAIRYU_IGNITION_FILTER_TYPE_DEVICE_ID = 'device_id';
export const TAIRYU_IGNITION_FILTER_TYPE_ROAD_AREA = 'road_area';
export const TAIRYU_IGNITION_FILTER_TYPE_GEO_AREA = 'geo_area';
